module.exports = __WEBPACK_EXTERNAL_MODULE_75__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 75
// module chunks = 0